// extracted by mini-css-extract-plugin
export default {"arrowBack":"style_arrowBack__75kil","icon":"style_icon__OO+qf"};